import 'babel-polyfill';
import 'script-loader!node_modules/jquery/dist/jquery.min.js';

// uncomment if you need to do expand/collapse:
import 'node_modules/bootstrap-sass/assets/javascripts/bootstrap/collapse.js';
import 'node_modules/bootstrap-sass/assets/javascripts/bootstrap/transition.js';

import { Global } from 'js/common/global.js';
import { OnReady } from 'js/components/Util/Browser.js';
import { Yext } from 'js/components/Soy2js/Soy2js.js'; // NOTE: if not using soy2js, replace with window.Yext = window.Yext || {};

import { DistanceCalculator } from 'ts/components/DistanceCalculator/index.ts';
import { Sniffer } from 'ts/components/Sniffer/index.ts';

import { GoogleAnalytics } from 'js/components/GoogleAnalytics/index.js';
import { Image } from 'js/components/Image/index.js';
import { LocationHours } from 'js/components/LocationHours/index.js';
import { Maps } from 'js/components/Maps/index.js';
import { LocatorAce } from 'js/search/modules/LocatorAceGoogle.js';
import { ResultList } from 'js/common/modules/ResultList.js';
import { PromoBanner } from 'js/search/modules/PromoBanner.js';

Global.init();
GoogleAnalytics.enableAutotracking('yext');

const initAppPromoBanner = () => {
  const isEn = document.documentElement.getAttribute('lang') === 'en';

  PromoBanner.init({
    appleAppStoreLink: 'https://apps.apple.com/app/apple-store/id386960831?pt=357513&ct=storelocator&mt=8',
    googlePlayStoreLink: 'https://play.google.com/store/apps/details?id=com.coppi.bestbuy&referrer=utm_source%3Dstorelocator',
    otherLink: isEn ? 'https://www.bestbuy.ca/en-ca/about/best-buy-canada-app/blt67e2d23c29c2b62e' : 'https://www.bestbuy.ca/fr-ca/a-propos/best-buy-canada-app/blt67e2d23c29c2b62e',
    androidTrackEvent: 'promo_android',
    iosTrackEvent: 'promo_ios',
    otherTrackEvent: 'promo_other',
  });
};

OnReady(() => {
  LocationHours.loadAndRun();
  LocatorAce.init({
    afterRender: initAppPromoBanner,
  });
  initAppPromoBanner();
  $('#js-map-wrapper').on('shown.bs.collapse', function () {
    window.dispatchEvent(new Event('resize'));
  });
});
